import React, { createContext, useState } from "react";
import { useContext } from "react";

export interface IoSettings {
  ruimte: boolean;
  uitgang: boolean;
  leemaken: boolean;
}

export interface UserSettings {
  id: number;
  user_id: number;
  pakket: boolean;
  onlysa: boolean;
  standardUitvoering: string;
  maxadres: number;
}

interface SettingsContextType {
  ioSettings: IoSettings | null;
  setIoSettings: React.Dispatch<React.SetStateAction<IoSettings | null>>;
  userSettings: UserSettings | null;
  setUserSettings: React.Dispatch<React.SetStateAction<UserSettings | null>>;
}

export const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [ioSettings, setIoSettings] = useState<IoSettings | null>(null);
  const [userSettings, setUserSettings] = useState<UserSettings | null>(null);

  return (
    <SettingsContext.Provider value={{ ioSettings, setIoSettings, userSettings, setUserSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};
